var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 9.33333H25.0547C25.2503 8.68505 25.3443 8.01039 25.3334 7.33333C25.3334 4.76 23.2401 2.66667 20.6667 2.66667C18.5041 2.66667 17.0601 4.64267 16.1281 6.78C15.2094 4.76 13.6921 2.66667 11.3334 2.66667C8.76008 2.66667 6.66675 4.76 6.66675 7.33333C6.66675 8.128 6.77208 8.78533 6.94541 9.33333H5.33341C3.86275 9.33333 2.66675 10.5293 2.66675 12V14.6667C2.66675 16.1373 3.86275 17.3333 5.33341 17.3333V26.6667C5.33341 28.1373 6.52941 29.3333 8.00008 29.3333H24.0001C25.4707 29.3333 26.6667 28.1373 26.6667 26.6667V17.3333C28.1374 17.3333 29.3334 16.1373 29.3334 14.6667V12C29.3334 10.5293 28.1374 9.33333 26.6667 9.33333ZM20.6667 5.33333C21.7694 5.33333 22.6667 6.23067 22.6667 7.33333C22.6667 9.33333 21.8321 9.33333 21.3334 9.33333H18.0294C18.7107 7.232 19.7001 5.33333 20.6667 5.33333ZM9.33341 7.33333C9.33341 6.23067 10.2307 5.33333 11.3334 5.33333C12.5174 5.33333 13.6187 7.36667 14.2641 9.33333H10.6667C10.1681 9.33333 9.33341 9.33333 9.33341 7.33333ZM5.33341 12H14.6667V14.6667H5.33341V12ZM8.00008 26.6667V17.3333H14.6667V26.6667H8.00008ZM24.0001 26.6667H17.3334V17.3333H24.0001V26.6667ZM17.3334 14.6667V12.1133L17.3561 12H26.6667L26.6681 14.6667H17.3334Z",
    fill: "url(#paint0_linear_855_2036)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_855_2036",
    x1: 3.0477,
    y1: 4.05556,
    x2: 17.3072,
    y2: 33.9573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.5a5cd9c6c3e9207d9f14519e3579fe5c.svg";
export { ForwardRef as ReactComponent };